import LeftNav from './LeftNav';

export default LeftNav;
